import { Input, Autocomplete, AutocompleteItem, Switch } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

/**
 * Filter component for Stock Summary (Data) page
 * Backend: stocks/data
 * Filters: warehouse_id, search, category_id, out_of_stock
 *
 * @param {Object} table - Table hook instance
 * @param {Object} initialFilters - Initial filter values
 * @param {Object} filterOptions - Options for select filters (passed from parent)
 *   - warehouses: Array of { value, title }
 *   - categories: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const { warehouses = [], categories = [] } = filterOptions;

    // Handle clear
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Pencarian Material */}
            <Input
                label="Cari Material"
                placeholder="Nama material..."
                value={pending.search || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({ ...prev, search: val }))
                }
                variant="flat"
                isClearable
            />

            {/* Gudang */}
            <Autocomplete
                label="Gudang"
                placeholder="Semua gudang"
                selectedKey={
                    pending.warehouse_id ? String(pending.warehouse_id) : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        warehouse_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {warehouses.map((w) => (
                    <AutocompleteItem key={String(w.value)} value={w.value}>
                        {w.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>

            {/* Kategori */}
            <Autocomplete
                label="Kategori"
                placeholder="Semua kategori"
                selectedKey={
                    pending.category_id ? String(pending.category_id) : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        category_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {categories.map((c) => (
                    <AutocompleteItem key={String(c.value)} value={c.value}>
                        {c.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>

            {/* Stok Habis Toggle */}
            <div className="flex items-center gap-2">
                <Switch
                    isSelected={pending.out_of_stock === "1"}
                    onValueChange={(checked) =>
                        setPending((prev) => ({
                            ...prev,
                            out_of_stock: checked ? "1" : "",
                        }))
                    }
                    size="sm"
                >
                    Hanya Stok Habis
                </Switch>
            </div>
        </FilterCard>
    );
};

export default FilterData;
